<template>
  <div>
    <el-dialog
      class="course-site-modal-contain clearfix"
      :visible.sync="dialogShow"
      :close-on-click-modal="true"
      :close-on-press-escape="true"
      :show-close="true"
      :before-close="handleCloseModal"
      :width="'1200px'"
      :append-to-body="true"
      :title="$t('courseSchedule.stieChose')"
    > 
      <p class="modal-title" v-if="isCourse">{{ $t('courseTask.siteDisableInfo') }}</p>
      <p class="modal-title modal-title2" v-if="isCourse">{{ $t('courseTask.siteDisableInfo2') }}</p>
      <p class="modal-title modal-title2" v-if="isCourse">{{ $t('courseTask.siteDisableInfo3') }}</p>
      <div class="modal-content modal-content1">
        <article class="course-site-filter clearfix">
          <div class="course-site-filter-lf clearfix">
            <div class="filter-module">
              <span class="filter-module-name">{{ $t('courseSchedule.stieName') }}</span>
              <span class="filter-module-value">
                <el-input
                  v-model="siteSearch.siteCnName"
                  @keyup.enter.native="searchList()"
                  clearable
                  :placeholder="$t('contract.inputTips')"
                ></el-input>
              </span>
            </div>
            <div class="filter-module">
              <span class="filter-module-name">{{ $t('courseSchedule.stieIndex') }}</span>
              <span class="filter-module-value">
                <el-input
                  v-model="siteSearch.siteNo"
                  @keyup.enter.native="searchList()"
                  clearable
                  :placeholder="$t('contract.inputTips')"
                ></el-input>
              </span>
            </div>
            <div class="filter-module">
              <span class="filter-module-name">{{ $t('courseSchedule.stieType') }}</span>
              <span class="filter-module-value">
                 <class-tree ref="classRef"
                          v-on:getSelectList="getSelectList"
                          v-bind:defaultProps="defaultSiteProps"
                          v-bind:url="querySiteTreeUrl"
                          v-on:clearTreeInfo="clearSiteTree"
                          v-bind:listName="'siteinfo'"
                          v-bind:isSelect="false"
                          :calWidth="180"
                          v-bind:status="'siteClassStatus'"></class-tree>
              </span>
            </div>
            <div class="filter-module">
              <span class="filter-module-name">{{ $t('courseSchedule.stieCity') }}</span>
              <span class="filter-module-value">
                 <class-tree ref="cityclassRef"
                    v-on:getSelectList="getcitySelectList"
                    v-bind:defaultProps="citydefaultProps"
                    v-bind:isOpen="false"
                    :calWidth="180"
                    v-bind:url="queryCityTreeUrl"
                    v-bind:isSelect="false"
                    v-on:clearTreeInfo="cityclassInfo"
                    v-bind:listName="'city'"></class-tree>
              </span>
            </div>
            <div class="filter-module">
              <span class="filter-module-name">{{ $t('courseSchedule.stieStatus') }}</span>
              <span class="filter-module-value">
                <el-select v-model="siteSearch.status" clearable>
                  <el-option
                    v-for="item in statusArr"
                    :key="'siteStatus'+item.code"
                    :label="item.name"
                    :value="item.code"
                  >
                  </el-option>
                </el-select>
              </span>
            </div>
          </div>
          <div class="course-site-filter-lr">
            <el-button class="filter-margin" type="primary" @click="searchList">
              {{ $t("query") }}
            </el-button>
            <el-button class="el-back" type="info" @click="resetList">
              {{ $t("reset") }}
            </el-button>
          </div>
        </article>
        <article class="course-site-content">
          <el-table border class="course-site-table"
            ref="siteTable"
            :data="siteData"
            stripe
            @select="selectRedio"
            @select-all="selectAll"
            v-loading="tableLoading">
            <template slot="empty">
              <p style="color: #969799">{{ $t('courseSchedule.noSite') }}</p>
            </template>
            <el-table-column
              type="selection"
              header-align="center"
              align="center"
              :selectable="selectInit"
              width="55">
            </el-table-column>
            <template v-for="(item,kindex) in courseColumn">
              <el-table-column :prop="item.prop"
                            :key="'courseChose'+item.prop"
                            show-overflow-tooltip
                            :width="item.width"
                            header-align="center"
                            align="center"
                            v-if="item.prop!=='courseDays'"
                            :formatter="item.formatter"
                            :label="item.label">
              </el-table-column>
              <el-table-column :prop="item.prop"
                            :key="'courseChose'+item.prop"
                            show-overflow-tooltip
                            :width="item.width"
                            header-align="center"
                            align="center"
                            v-else
                            :label="item.label">
                  <template slot-scope="scope">
                    <span>{{ scope.row[item.prop] ? scope.row[item.prop].toFixed(2) : '0.00' }}</span>
                  </template>
              </el-table-column>
            </template>
          </el-table>
          <el-pagination
            :current-page="pageNum"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            :total="total"
            class="course-site-pagination"
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="pageSizeChangeHandle"
            @current-change="pageCurrentChangeHandle"
          >
          </el-pagination>
        </article>
      </div>
      <div class="modal-content modal-content2">
        <div class="modal-content-list">
          <el-button type="primary" @click="saveSite">
              {{ $t("save") }}
            </el-button>
        </div>
        <div class="modal-content-list modal-content-list2">
          <p class="list-chose">{{ $t('res.site.selected') }}</p>
          <div class="save-list-li" v-for="(item,index) in selection">
            <el-tag show-overflow-tooltip
              :key="item.siteId"
              @close="handleCloseSelect(index)"
              :disable-transitions="true"
              closable>
              <span class="save-list-li-name">{{ item.siteNo + '-' + item.siteCnName }}</span></el-tag> 
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import ClassTree from '@/components/rm/class-tree/index';

export default {
  components: {
    'class-tree': ClassTree
  },
  props: {
    dialogShow: {
      type: Boolean
    },
    isCourse: {
      type: Boolean
    },
    courseId: {
      type: String,
      default: ''
    },
    courseType: {
      type: String
    },
    siteIds: {
      type: Array
    },
    searchFlag: {
      type: Number
    },
    searchParam: {
      type: String
    }
  },
  data() {
    return {
      pageSize: 10,
      pageNum: 1,
      total: 0,
      siteSearch: {
        siteNo: '',
        siteCnName: '',
        status: null
      },
      selection: [],
      tableLoading: false,
      queryCityTreeUrl: '/rm/courseclassroomrela/queryregiontree',
      citydefaultProps: {
        children: 'childrenRegionList',
        label: 'regionNameCn'
      },
      querySiteTreeUrl: '/rm/siteclass/list',
      defaultSiteProps: {
        children: 'children',
        label: 'siteClassCnName'
      },
      yearList: [],
      cityList: [],
      siteClassList: [],
      statusArr: this.enums['status'],
      siteData: [],
      courseColumn: [
        { label: this.$t('courseSchedule.stieIndex'), prop: 'siteNo' },
        { label: this.$t('courseSchedule.stieName'), prop: 'siteCnName' },
        { label: this.$t('res.site.shortName'), prop: 'siteAbbr' },
        { label: this.$t('res.site.type'), prop: 'siteTypeName' },
        { label: this.$t('res.site.company'), prop: 'companyCnName' },
        { label: this.$t('res.site.city'), prop: 'cityName', width: 120 },
        { label: this.$t('res.site.classification'), prop: 'siteClassCnName' },
        { label: this.$t('res.site.status'), prop: 'statusName' }
      ],
      siteIdArr: []
    };
  },
  methods: {
    cityclassInfo (val) {
      if(val === 'city'){
        this.cityList = [];
      }
    },
    getSelectList (args) {
      this.siteClassList = args.map((item) => item.id) || [];
    },
    getcitySelectList (args) {
      this.cityList = args.map((item) => item.id) || [];
    },
    clearSiteTree (val){
      if(val === 'siteinfo'){
        this.siteClassList = [];
      }
    },
    handleCloseModal() {
      this.selection = [];
      this.siteData.forEach((item) => {
        if (this.siteIds.includes(item.siteId)) {
          this.selection.push(item);
        }
      });
      this.$emit('closeSiteChose', { siteInfo: this.selection, show: false });
    },
    selectInit (row) {
      return row.canSelectFlag;
    },
    resetList () {
      this.siteSearch = {
        siteCnName: '',
        siteNo: '',
        status: null
      };
      this.cityList = [];
      this.siteClassList = [];
      this.selection = [];
      this.siteIdArr = [];
      this.$refs.cityclassRef.resetChecked();
      this.$refs.classRef.resetChecked();
      this.searchList();
    },
    searchList () {
      this.pageNum = 1;
      this.pageSize = 10;
      this.getData();
    },
    querSelect () {
      const selectionIds = this.selection.map((item) => item.siteId);
      this.siteData.forEach((item) => {
        if (this.siteIdArr.includes(item.siteId) || selectionIds.includes(item.siteId)) {
          this.$refs.siteTable.toggleRowSelection(item);
          if (!selectionIds.includes(item.siteId)) {
            this.selection.push(item);
          }
        }
      });
    },
    getData () {
      const params = {
        siteCnName: this.siteSearch.siteCnName,
        siteNo: this.siteSearch.siteNo,
        siteClassList: this.siteClassList,
        cityClassList: this.cityList,
        status: this.siteSearch.status
      };
      if (this.isCourse && this.courseId) {
        params.courseId = this.courseId;
        params.searchFlag = this.searchFlag;
        params.searchParam = this.searchParam;
      }
      if (this.courseType) {
        params.courseType = this.courseType;
      }
      this.tableLoading = true;
      this.$request.post(`/classschedule/scheduleTarget/sitePage?page=
      ${this.pageNum}&limit=${this.pageSize}`, params).then((res) => {
        if (res) {
          this.total = res.total;
          this.siteData = res.records || [];
          this.tableLoading = false;
          this.$nextTick(() => {
            this.querSelect();
          });
        }
      }).catch(() => {
        this.tableLoading = false;
      });
    },
    handleCloseSelect (index) {
      for(let i of this.siteData) {
        if (i.siteId === this.selection[index].siteId) {
          this.$refs.siteTable.toggleRowSelection(i, false);
          break;
        }
      }
      this.selection.splice(index, 1);
    },
    selectRedio (_selection, row) {
      const ids = this.selection.map((item) => item.siteId);
      if (!ids.includes(row.siteId)) {
        this.selection.push(row);
      } else {
        this.$refs.siteTable.toggleRowSelection(row, false);
        this.selection.splice( ids.indexOf(row.siteId), 1);
      }
    },
    selectAll (selection) {
      if (selection.length > 0) {
        const ids = this.selection.map((item) => item.siteId);
        selection.forEach((item) => {
          if (!ids.includes(item.siteId)) {
            this.selection.push(item);
          }
        });
      } else {
        const delIds = this.siteData.map((item) => item.siteId);
        const arr = [];
        this.selection.forEach((item) => {
          if (delIds.includes(item.siteId)) {
            this.$refs.siteTable.toggleRowSelection(item, false);
          } else {
            arr.push(item);
          }
        });
        this.selection = arr;
      }
    },
    pageSizeChangeHandle (val) {
      this.pageSize = val;
      this.pageNum = 1;
      this.getData();
    },
    pageCurrentChangeHandle (val) {
      this.pageNum = val;
      this.getData();
    },
    saveSite () {
      if (this.selection.length === 0) {
        this.$message({
          message: this.$t('courseSchedule.siteInfo'),
          type: 'warning',
        });
        return false;
      }
      this.$emit('closeSiteChose', { siteInfo: this.selection, show: false });
    }
  },
  mounted() {
    this.selection = [];
    this.siteIdArr = JSON.parse(JSON.stringify(this.siteIds));
    this.searchList();
  },
};
</script>
<style lang="scss" scoped>
.course-site-modal-contain {
  .modal-title {
    width: 100%;
    margin: 0;
    line-height: 20px;
    padding-right: 272px;
    &.modal-title2 {
      padding-left: 42px;
    }
  }
  .modal-content {
    background: #fff;
    border: 1px solid #dcdfe6;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, .12), 0 0 6px 0 rgba(0, 0, 0, .04);
    padding: 20px;
    margin-top: 10px;
    &.modal-content1 {
      flex: 1;
      overflow: hidden;
    }
    &.modal-content2 {
      width: 260px;
      margin-left: 12px;
      box-shadow: none;
      border: none;
      padding: 0;
      .modal-content-list {
        height: 60px;
        padding: 10px;
        border: 1px solid #dcdfe6;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, .12), 0 0 6px 0 rgba(0, 0, 0, .04);
        margin-bottom: 12px;
        text-align: right;
        &.modal-content-list2 {
          height: calc(100% - 72px);
          margin: 0;
          text-align: center;
        }
      }
    }
    .course-site-filter {
      .course-site-filter-lf {
        float: left;
        width: calc(100% - 100px);
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        .filter-module {
          flex: 0 0 32%;
          padding-right: 3%;
          margin-bottom: 12px;
          line-height: 34px;
          .filter-module-name {
            display: block;
            float: left;
            width: 60px;
            margin-right: 10px;
            text-align: left;
          }
          .filter-module-value {
            display: block;
            float: left;
            width: calc(100% - 70px);
          }
        }
      }
      .course-site-filter-lr {
        width: 100px;
        float: left;
        .el-button {
          width: 100% !important;
          margin: 0;
        }
        .filter-margin {
          margin-bottom: 10px;
        }
      }
    }
    .course-site-pagination {
      text-align: right;
      margin-top: 10px;
    }
    .save-list-li {
      margin-bottom: 10px;
    }
    .save-list-li-name {
      width: 190px;
      display: inline-block;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .course-site-table {
      overflow: hidden;
    }
  }
  .el-tag {
    width: 100% !important;
  }
}
</style>
<style lang="scss">
.course-site-modal-contain {
  .el-table__header .el-checkbox {
    display: block !important;
  }
  .el-dialog__body {
    padding: 10px 20px !important;
    display: flex;
    flex-wrap: wrap;
  }
  .el-table__header {
    th {
      background-color: #ebecf0 !important;
      border-right: 1px #dcdee3 solid !important;
    }
  }
  .el-tag {
    .el-icon-close {
      top: -12px !important;
    }
  }
}
</style>